export default __webpack_public_path__ + "static/DentalQualysVoiceover-302c635f6a9ebfcbb1e5e912151acd62.png";